import { useMemo } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useTranslation } from "react-i18next";
import Table from "@/components/tableDrawer/TableItems";
import ScreenHeader from "@/components/ScreenHeader";
import "./style.css";
import IconBtn from "@/components/ActionBtn/IconBtn/IconBtn";
import ActionBtn from "@/components/ActionBtn";
import Badge from "../../../shared/Badge/Badge";
import { useNavigate, useParams } from "react-router-dom";

const HospitalOffers = ({ hospitals, onSelectHospital, selectedHospital }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {id, medicalOrderId} = useParams();

  const showHospitalOffers = (hospitalRequestId) => {
    navigate(`/panel/account-manager/medical-requests/${id}/${medicalOrderId}/${hospitalRequestId}`);
  }

  const columns = useMemo(() => [
    {
      Header: t("hospital"),
      accessor: "name",
      Cell: ({ row: { original: h } }) => {
          const isSelected = selectedHospital?.id == h.id;
        return (
          <div
            className="ho-hospital-cell"
            onClick={() => onSelectHospital(h)}
            style={{ cursor: "pointer" }}
          >
            <span className={`ho-checkbox ${isSelected ? "ho-checkbox--checked" : ""}`}>
              {isSelected && <Icon icon="ph:check-fill" className="ho-check-icon" />}
            </span>
            <span className="ho-hospital-name">{h.name}</span>
          </div>
        );
      },
    },
    {
      Header: t("bid-price"),
      accessor: "price",
      Cell: ({ row: { original: h } }) => (
        <span className="ho-price">${h.price?.toLocaleString()}</span>
      ),
    },
    {
      Header: t("sla-status"),
      accessor: "slaStatus",
      Cell: ({ row: { original: h } }) => (
        <Badge title={h.sla} className={`ho-badge ho-badge--${h.sla?.toLowerCase()}`} />
      ),
    },
    {
      Header: t("review"),
      id: "review-column",
      Cell: ({ row: { original: h } }) => (
        <ActionBtn onApply={() => showHospitalOffers(h.id)} title={t("view")} icon="ph:file-text-light" />
      ),
    },
  ], [t, selectedHospital]);
  const assignRelatedClass = (cells) => {
    const id = cells?.[0]?.row?.original?.id;
    return id === selectedHospital?.id ? "ho-row--selected" : "";
  };

  return (
    <div className="ho-card bg-white">
      <ScreenHeader title="select-best-hospital-offer" className="bg-transparent mx-0 px-0" />

      <Table
        columns={columns}
        data={hospitals || []}
        isPagination={false}
        isNeedFetch={false}
        TotalRows={hospitals?.length || 0}
        assignRelatedClass={assignRelatedClass}
      />
    </div>
  );
};

export default HospitalOffers;
